import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'

import './BrandLink.css'

const BrandLink = ({ brand, facet }) => {
  return (
    <Link
      className="prduct-detail-cart__brand-link"
      key="pdp-brand"
      to={`/search?query=${encodeURIComponent(brand)}&page=1&refinementList[${
        facet || 'filters.Marca'
      }][]=${encodeURIComponent(brand)}`}
      target="_self"
    >
      {brand}
    </Link>
  )
}

BrandLink.defaultProps = {
  facet: '',
}

BrandLink.propTypes = {
  facet: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  brand: PropTypes.string.isRequired,
}

export default BrandLink
